import z from "zod";
import { OrderItemDeliveryLabelPatchCommandStatusEnum } from "@/config/apiClient";

export const modalValidateDeliveryLabelSchema = z.object({
  deliveryLabelStatus: z.enum(OrderItemDeliveryLabelPatchCommandStatusEnum),
  comment: z.string().optional(),
});

export type InferredModalValidateDeliveryLabelSchema = z.infer<
  typeof modalValidateDeliveryLabelSchema
>;
